import { useContext, useEffect } from "react";

// CONTEXT.
import { SettingsContext, PrincipalContext } from "src/context";

// CHECK WHAT SHOULD BE DISPLAYED FOR HOURS.
// Store Override Toggle > Store Holiday > Store Seasonal > Store Hours > Center Override Toggle > Center Holiday > Center Seasonal > Center Hours

export const WeeksHours = (type, store, date, schema) => {
    const [principal, setPrincipal] = useContext(PrincipalContext);
    const [settings] = useContext(SettingsContext);
    const fromDate = date ? date : new Date();
    const firstDay = getMonday(fromDate);
    const lastDay = getSunday(fromDate);
    const month = (new Date()?.getMonth() + 1)?.toString();
    const week = [];
    const weekDays = [];
    let weekSpread = '';

    if (principal.activeTranslation === 'fr') {
            if (getMonthName(lastDay.getMonth()) !== getMonthName(firstDay.getMonth())) {
            weekSpread = `${firstDay.getDate()}${nth(firstDay.getDate())} ${getMonthName(firstDay.getMonth())} - ${lastDay.getDate()}${nth(lastDay.getDate())} ${getMonthName(lastDay.getMonth())}`;
        } else {
            weekSpread = `${firstDay.getDate()}${nth(firstDay.getDate())} - ${lastDay.getDate()}${nth(lastDay.getDate())} ${getMonthName(lastDay.getMonth())}`;
        }
    } else {
        weekSpread = `${getMonthName(firstDay.getMonth())} ${firstDay.getDate()}${nth(firstDay.getDate())} - ${getMonthName(lastDay.getMonth()) !== getMonthName(firstDay.getMonth()) ? getMonthName(lastDay.getMonth()) : ''} ${lastDay.getDate()}${nth(lastDay.getDate())}`;
    }

    for (let i = 0; i < 7; i++) {
        let itemStamp = new Date(firstDay.getTime() + (3600 * 1000 * 24 * i));
        let itemDate = itemStamp.getDate();
        let itemMonth = itemStamp.getMonth() + 1;
    
        // DISPLAY TYPES.
        if (type === 'reduced' || type === 'condensed_list') {
            week.push(store ? StoreHours(store, itemStamp) : CenterHours(itemStamp));
        } else if (type === 'reduced-widget') {
            week.push(CenterHours(itemStamp));
        } else if (type === 'list') {
            weekDays.push(`${getDayName(itemStamp.getDay(), 'short')} <span>${store ? StoreHours(store, itemStamp) : CenterHours(itemStamp)}</span>`)
        } else if (type === 'special') {
            weekDays.push(`${getDayName(itemStamp.getDay(), 'long-cap')}: <span>${store ? StoreHours(store, itemStamp) : CenterHours(itemStamp)}</span>`)
        } else if (type === 'dropdown') {
            weekDays.push(`<span>${getDayName(itemStamp.getDay(), 'long-cap')} <span>${itemMonth}/${itemDate}</span></span><span>${CenterHours(itemStamp)}</span>`)
        } else if (type === 'daily') {
            weekDays.push(`<p class="weekday strong uppercase">${getDayName(itemStamp.getDay(), 'long-cap')}</p><p class="hours">${CenterHours(itemStamp)}</p>`)
        } else {
            weekDays.push(`${getDayName(itemStamp.getDay(), 'long')}: <span>${store ? StoreHours(store, itemStamp) : CenterHours(itemStamp)}</span>`)
        }
    }

    // consolidate days (logic taken from centers)
    let startDayOfWeek = settings.mvk_theme_config?.labels?.day_labels?.monday ? settings.mvk_theme_config?.labels?.day_labels?.monday : 'Mon';
    let daysOfWeek = settings.mvk_theme_config?.labels?.day_labels?.monday ? settings.mvk_theme_config?.labels?.day_labels?.monday : 'Mon';
    let hourOfDay = week[0];
    let hasMatchingDays = false;

    let reducedDays = type === 'reduced' ? `${weekSpread} / ` : '';
    reducedDays += checkDays(week[0], week[1],  settings.mvk_theme_config?.labels?.day_labels?.tuesday ?  settings.mvk_theme_config?.labels?.day_labels?.tuesday : 'Tues', type);
    reducedDays += checkDays(week[1], week[2],  settings.mvk_theme_config?.labels?.day_labels?.wednesday ?  settings.mvk_theme_config?.labels?.day_labels?.wednesday : 'Wed', type);
    reducedDays += checkDays(week[2], week[3],  settings.mvk_theme_config?.labels?.day_labels?.thursday ?  settings.mvk_theme_config?.labels?.day_labels?.thursday : 'Thur', type);
    reducedDays += checkDays(week[3], week[4],  settings.mvk_theme_config?.labels?.day_labels?.friday ?  settings.mvk_theme_config?.labels?.day_labels?.friday : 'Fri', type);
    reducedDays += checkDays(week[4], week[5],  settings.mvk_theme_config?.labels?.day_labels?.saturday ?  settings.mvk_theme_config?.labels?.day_labels?.saturday : 'Sat', type);
    reducedDays += checkDays(week[5], week[6],  settings.mvk_theme_config?.labels?.day_labels?.sunday ?  settings.mvk_theme_config?.labels?.day_labels?.sunday : 'Sun', type);
    reducedDays += checkDays(week[6], 0,  settings.mvk_theme_config?.labels?.day_labels?.monday ?  settings.mvk_theme_config?.labels?.day_labels?.monday : 'Mon', type);

    function checkDays(day1, day2, dayTitle, type) {
        if (type === 'reduced-widget') {
            dayTitle = dayTitle.toUpperCase();
            startDayOfWeek = startDayOfWeek.toUpperCase();
        }
        if (day1 === day2) {
            daysOfWeek = startDayOfWeek + ' - ' + dayTitle;
            hasMatchingDays = true;
            return '';
        } else {
            if (hasMatchingDays) {
                hasMatchingDays = false;
                daysOfWeek = daysOfWeek + (type !== 'reduced' ? ' // ' : ' - ') + day1;
            } else {
                daysOfWeek = startDayOfWeek + (type !== 'reduced' ? ' // ' : ' - ') + day1;
            }

            startDayOfWeek = dayTitle;
            hourOfDay = day2;
            return (dayTitle.toLowerCase() !== 'mon' ? daysOfWeek + ((type !== 'reduced') ? '<br />' : " / ") : daysOfWeek);
        }
    }
    if (schema) {
        return transformSchedule(reducedDays);
    }
    else if (type === 'reduced' || type === 'reduced-widget') {
        return reducedDays;
    } else if (type === 'condensed_list') {
        return reducedDays.replaceAll(' // ', ': ');
    } else {
        return { currentWeek: weekSpread, hours: weekDays };
    }
};

export const StoreHours = (store, date) => {
    const day = getSetDayName(date.getDay());
    const time = date.getTime();

    if (store?.custom_hours_message) {
        return store.custom_hours_message;
    }

    if (store?.alternate_hours && Array.isArray(store?.alternate_hours)) {
        const holiday = checkForHoliday(store.alternate_hours, time, true);
        if (holiday) { return holiday; }
    }

    if (store?.seasonal_hours && Array.isArray(store?.seasonal_hours)) {
        const seasonal = checkForSeasonal(store.seasonal_hours, time, day, true);
        if (seasonal) { return seasonal; }
    }

    if (store?.standard_hours && Array.isArray(store?.standard_hours)) {
        const standard = checkForStandard(store.standard_hours[0], day, true);
        if (standard) {
            return standard;
        }
    }

    return CenterHours(date);
};

export const CenterHours = (date, messageCheck = true) => {
    const [settings, setSettings] = useContext(SettingsContext);
    const [principal, setPrincipal] = useContext(PrincipalContext);
    const day = getSetDayName(date.getDay());
    const time = date.getTime();

    if (settings.hours) {
        if (messageCheck) {
            if (settings.hours?.custom_hours_message) {
                return settings.hours?.custom_hours_message;
            }
        }
        if (principal.primaryHours?.alternate_hours && Array.isArray(principal.primaryHours?.alternate_hours)) {
            const holiday = checkForHoliday(principal.primaryHours?.alternate_hours, time);
            if (holiday) {
                return holiday;
            }
        }

        if (principal.primaryHours?.seasonal_hours && Array.isArray(principal.primaryHours?.seasonal_hours)) {
            const seasonal = checkForSeasonal(principal.primaryHours?.seasonal_hours, time, day);
            if (seasonal) {
                return seasonal;
            }
        }

        if (principal.primaryHours?.standard_hours && Array.isArray(principal.primaryHours?.standard_hours)) {
            const standard = checkForStandard(principal.primaryHours?.standard_hours[0], day);
            if (standard) {
                return standard;
            }
        }
    }
};

// PRIVATE FUNCTIONS.

// set day names since now the day names might be a different language and the field names still use the english words
const getSetDayName = (day) => {
    return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][day];
}

function checkForHoliday(alternate_hours, time, isStore) {
    const [settings, setSettings] = useContext(SettingsContext);
    const [principal, setPrincipal] = useContext(PrincipalContext);
    time = Math.floor(time / 1000)

    const holiday = alternate_hours?.find(alternate_hour => {
        return time >= alternate_hour.date_start && time <= alternate_hour.date_end;
    });
    if (holiday) {
        if (holiday.closed) {
            return settings?.hours?.standard_hours[0]?.closed_label ? settings?.hours?.standard_hours[0]?.closed_label : 'Closed';
        } else {
            if (holiday.start_time && holiday.end_time) {
                if (principal.activeTranslation === 'fr') {
                    return `${convertToFrench(holiday.start_time)} - ${convertToFrench(holiday.end_time, isStore)}`;
                } else {
                    return `${holiday.start_time} - ${holiday.end_time}`;
                }
            }
        }
    }
};

function checkForSeasonal(seasonal_hours, time, day, isStore) {
    const [settings, setSettings] = useContext(SettingsContext);
    const [principal, setPrincipal] = useContext(PrincipalContext);
    time = Math.floor(time / 1000)

    const seasonal = seasonal_hours?.find(seasonal_hour => {
        return time >= seasonal_hour.season_start_date && time <= seasonal_hour.season_end_date;
    });

    if (seasonal) {
        if (seasonal[`${day}_closed`]) {
            return seasonal[`${day}_custom`] ? `<span class='custom'>${seasonal[`${day}_custom`]}</span>` : `<span class="custom">${settings?.hours?.standard_hours[0]?.closed_label ? settings?.hours?.standard_hours[0]?.closed_label : 'Closed'}</span>`;
        } else {
            if (seasonal[`${day}_open`] && seasonal[`${day}_close`]) {
                if (principal.activeTranslation === 'fr') {
                    return `${convertToFrench(seasonal[`${day}_open`])} - ${convertToFrench(seasonal[`${day}_close`], isStore)}`;
                } else {
                    return `${seasonal[`${day}_open`]} - ${seasonal[`${day}_close`]}`;
                }
            }
        }
    }
};

function checkForStandard(standard_hours, day, isStore) {
    const [settings, setSettings] = useContext(SettingsContext);
    const [principal, setPrincipal] = useContext(PrincipalContext);

    if (standard_hours[`${day}_closed`]) {
        return standard_hours[`${day}_custom`] ? `<span class='custom'>${standard_hours[`${day}_custom`]}</span>` : `<span class="custom">${settings?.hours?.standard_hours[0]?.closed_label ? settings?.hours?.standard_hours[0]?.closed_label : 'Closed'}</span>`;
    } else {
        if (standard_hours[`${day}_open`] && standard_hours[`${day}_close`]) {
            if (principal.activeTranslation === 'fr') {
                return `${convertToFrench(standard_hours[`${day}_open`])} - ${convertToFrench(standard_hours[`${day}_close`], isStore)}`;
            } else {
                return `${standard_hours[`${day}_open`]} - ${standard_hours[`${day}_close`]}`;
            }
        }
    }
};

// day names are now kept in translateble acf fields, defaulting to english
const getDayName = (day, style) => {
    const [settings, setSettings] = useContext(SettingsContext);
    var days = null;
    if (style == 'short') {
        days = [
            settings.mvk_theme_config?.labels?.day_labels?.sunday ? settings.mvk_theme_config?.labels?.day_labels?.sunday : 'sun',
            settings.mvk_theme_config?.labels?.day_labels?.monday ? settings.mvk_theme_config?.labels?.day_labels?.monday : 'mon',
            settings.mvk_theme_config?.labels?.day_labels?.tuesday ? settings.mvk_theme_config?.labels?.day_labels?.tuesday : 'tue',
            settings.mvk_theme_config?.labels?.day_labels?.wednesday ? settings.mvk_theme_config?.labels?.day_labels?.wednesday : 'wed',
            settings.mvk_theme_config?.labels?.day_labels?.thursday ? settings.mvk_theme_config?.labels?.day_labels?.thursday : 'thur',
            settings.mvk_theme_config?.labels?.day_labels?.friday ? settings.mvk_theme_config?.labels?.day_labels?.friday : 'fri',
            settings.mvk_theme_config?.labels?.day_labels?.saturday ? settings.mvk_theme_config?.labels?.day_labels?.saturday : 'sat'
        ];
    } else if (style == 'long-cap') {
        days = [
            settings.mvk_theme_config?.labels?.day_labels?.sunday ? settings.mvk_theme_config?.labels?.day_labels?.sunday : 'Sunday',
            settings.mvk_theme_config?.labels?.day_labels?.monday ? settings.mvk_theme_config?.labels?.day_labels?.monday : 'Monday',
            settings.mvk_theme_config?.labels?.day_labels?.tuesday ? settings.mvk_theme_config?.labels?.day_labels?.tuesday : 'Tuesday',
            settings.mvk_theme_config?.labels?.day_labels?.wednesday ? settings.mvk_theme_config?.labels?.day_labels?.wednesday : 'Wednesday',
            settings.mvk_theme_config?.labels?.day_labels?.thursday ? settings.mvk_theme_config?.labels?.day_labels?.thursday : 'Thursday',
            settings.mvk_theme_config?.labels?.day_labels?.friday ? settings.mvk_theme_config?.labels?.day_labels?.friday : 'Friday',
            settings.mvk_theme_config?.labels?.day_labels?.saturday ? settings.mvk_theme_config?.labels?.day_labels?.saturday : 'Saturday'
        ];
    } else {
        days = [
            settings.mvk_theme_config?.labels?.day_labels?.sunday ? settings.mvk_theme_config?.labels?.day_labels?.sunday : 'sunday',
            settings.mvk_theme_config?.labels?.day_labels?.monday ? settings.mvk_theme_config?.labels?.day_labels?.monday : 'monday',
            settings.mvk_theme_config?.labels?.day_labels?.tuesday ? settings.mvk_theme_config?.labels?.day_labels?.tuesday : 'tuesday',
            settings.mvk_theme_config?.labels?.day_labels?.wednesday ? settings.mvk_theme_config?.labels?.day_labels?.wednesday : 'wednesday',
            settings.mvk_theme_config?.labels?.day_labels?.thursday ? settings.mvk_theme_config?.labels?.day_labels?.thursday : 'thursday',
            settings.mvk_theme_config?.labels?.day_labels?.friday ? settings.mvk_theme_config?.labels?.day_labels?.friday : 'friday',
            settings.mvk_theme_config?.labels?.day_labels?.saturday ? settings.mvk_theme_config?.labels?.day_labels?.saturday : 'saturday'
        ];
    }

    return days[day];
};

export function getMonthName(month) {
    const [settings, setSettings] = useContext(SettingsContext);
    return [
        settings?.mvk_theme_config?.labels?.month_labels?.month_1 || "January",
        settings?.mvk_theme_config?.labels?.month_labels?.month_2 || "February",
        settings?.mvk_theme_config?.labels?.month_labels?.month_3 || "March",
        settings?.mvk_theme_config?.labels?.month_labels?.month_4 || "April",
        settings?.mvk_theme_config?.labels?.month_labels?.month_5 || "May",
        settings?.mvk_theme_config?.labels?.month_labels?.month_6 || "June",
        settings?.mvk_theme_config?.labels?.month_labels?.month_7 || "July",
        settings?.mvk_theme_config?.labels?.month_labels?.month_8 || "August",
        settings?.mvk_theme_config?.labels?.month_labels?.month_9 || "September",
        settings?.mvk_theme_config?.labels?.month_labels?.month_10 || "October",
        settings?.mvk_theme_config?.labels?.month_labels?.month_11 || "November",
        settings?.mvk_theme_config?.labels?.month_labels?.month_12 || "December"
    ][month];
};

// ordinal indicator
function nth(day) {
    const [principal, setPrincipal] = useContext(PrincipalContext);

    if (principal.activeTranslation === 'fr') {
        if (day == 1) {
            return 'er'
        } else {
            return '';
        }
    } else {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return "st";
            case 2: return "nd";
            case 3: return "rd";
            default: return "th";
        };
    }
};

function getMonday(d) {
    const fromDate = new Date(d);
    var day = fromDate.getDay();
    var diff = fromDate.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(fromDate.setDate(diff));
};

function getSunday(d) {
    const fromDate = new Date(d);
    const day = fromDate.getDay();
    const first = fromDate.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    fromDate.setDate(first);
    const sunday = new Date(fromDate.setDate(fromDate.getDate() + 6));
    return sunday;
};

// convert to french - 24hr time with h instead of :
export const convertToFrench = (time12h, forcePM) => {
    const [time, modifier] = time12h ? time12h?.split(" ") : '';
    let [hours, minutes] = time ? time?.split(":") : '';
    if (hours === "12") {
        hours = "00";
    }
    if (modifier?.toLowerCase() === "pm" || modifier?.toLowerCase() === "p.m.") {
        hours = parseInt(hours, 10) + 12;
    }
    return `${hours}h${minutes}`;
};

function parseTime(timeString) {
    const [time, period] = timeString.trim().split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    if (period?.toLowerCase() === "pm" && hours !== 12) {
        hours += 12;
    } else if (period?.toLowerCase() === "am" && hours === 12) {
        hours = 0;
    }
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
}

function transformSchedule(input) {
    const parts = input.split(" / ").slice(1); // Skip the date part
    return parts.map(part => {
        const match = part.match(/^([\w\s\-]+) - ([\d: ]+[apm]+) - ([\d: ]+[apm]+)$/i);
        if (!match) {
            throw new Error(`Invalid schedule format: ${part}`);
        }
        const days = match[1].replace(/\s+/g, "");
        const startTime = parseTime(match[2].trim());
        const endTime = parseTime(match[3].trim());
        return `${days} ${startTime}-${endTime}`;
    });
}
